"use client";

import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import React from "react";
import { StorageOrderBy, storageOrderByOptions } from "../../../../types";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function OrderBy() {
    const { dir } = useLocale();
    const { foldersQuery, updateFoldersQuery } = useStorageQuery();
    const orderByOption = storageOrderByOptions.find(
        (o) => o.value === foldersQuery.orderBy
    );

    return (
        <DropdownMenu dir={dir}>
            <DropdownMenuTrigger asChild>
                <Button
                    className="gap-1 font-normal text-sm"
                    variant="outline"
                    size="sm"
                >
                    {t("storage.folders-grid.order-btn", undefined, undefined)}
                    : {t(orderByOption!.keyName, undefined, undefined)}
                    <ChevronDown className="size-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="bottom" align="end">
                <DropdownMenuRadioGroup
                    value={foldersQuery.orderBy}
                    onValueChange={(value: string) => {
                        updateFoldersQuery({
                            orderBy: value as StorageOrderBy,
                            page: 1,
                        });
                    }}
                >
                    {storageOrderByOptions.map((option) => (
                        <DropdownMenuRadioItem
                            key={option.value}
                            value={option.value}
                            className="text-sm"
                        >
                            {t(option.keyName, undefined, undefined)}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
